// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"224":"component---src-pages-en-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"224":"deb3425178371bebe1f7","678":"0abeea5d6d3af1bc6e95"}[chunkId] + ".js";
};